export default "__VITE_ASSET__i4cxxF6i__"